<template>
  <div id="dateInfo">
    <el-dialog
      :title="batchFormTitle"
      width="750px"
      :visible.sync="batchDialogVisible"
      :close-on-click-modal="false"
      @close="batchDialogClose"
    >
      <el-form
        ref="batchFormRef"
        :model="visitLimitForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item>
          <!--<vxe-toolbar>-->
          <!--<template #buttons >-->
          <!--<vxe-button @click="insertRowEvents()"> 新增 </vxe-button>-->
          <!--<vxe-button @click="deleteSelected()">删除选中</vxe-button>-->
          <!--</template>-->
          <!--</vxe-toolbar>-->
          <vxe-table
            ref="xTables"
            border
            resizable
            show-overflow
            keep-source
            :data="batchList"
            :edit-rules="validRulesS"
            :edit-config="{ trigger: 'click', mode: 'cell' }"
          >
            <!--<vxe-table-column type="checkbox" width="60"/> -->
            <vxe-table-column
              field="startTime"
              title="预约开始时间"
              :edit-render="{
                name: '$input',
                props: { type: 'datetime', clearable: true },
              }"
            />
            <vxe-table-column
              field="minute"
              title="间隔分钟"
              width="120px"
              :edit-render="{
                name: '$input',
                props: { type: 'integer', clearable: true },
              }"
            />
            <vxe-table-column
              field="dataNumber"
              title="预约数"
              width="120px"
              :edit-render="{
                name: '$input',
                props: { type: 'integer', clearable: true },
              }"
            />
            <vxe-table-column title="操作" width="70px">
              <template #default="{ row }">
                <template>
                  <vxe-button @click="removeRowEvents(row)">
                    删除
                  </vxe-button>
                </template>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="batchDialogVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="batchFormSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      width="440px"
      height="300px"
    >
      <el-form
        ref="contentFormRef"
        :model="visitLimitForm"
        :rules="contentRule"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="暂停原因" prop="content">
          <el-input
            v-model="visitLimitForm.content"
            placeholder="请输入暂停原因"
            clearable
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialogVisible = false">
          取 消
        </el-button>
        <el-button type="primary" @click="handleUpdateStatus()">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="visitLimitFormTitle"
      width="900px"
      :visible.sync="visitLimitDialogVisible"
      :close-on-click-modal="false"
      @close="visitLimitDialogClose"
    >
      <el-form
        ref="visitLimitFormRef"
        :model="visitLimitForm"
        label-position="right"
        label-width="100px"
      >
        <el-form-item>
          <vxe-toolbar v-if="this.visitLimitFormTitle === '修改可预约数'">
            <template #buttons>
              <vxe-button @click="insertRowEvent()">
                新增
              </vxe-button>
            </template>
          </vxe-toolbar>
          <vxe-table
            ref="xTable"
            border
            resizable
            show-overflow
            keep-source
            :data="visitLimitList"
            :edit-rules="validRules"
            :edit-config="{ trigger: 'click', mode: 'cell' }"
            @edit-actived="editActivedEvent"
          >
            <vxe-table-column
              field="startTime"
              title="预约开始时间"
              :edit-render="{
                name: '$input',
                props: {
                  type: 'datetime',
                  clearable: true,
                  disabled: startTimeDisabled,
                },
              }"
            />
            <!--<vxe-table-column
                                    field="startTime"
                                    title="预约开始时间"
                                    :edit-render="{}"
                            >
                            <template #edit="scope">
                                <vxe-input v-model="scope.row.startTime" type="datetime" @change="handleChanges(scope.$index,scope.row)"></vxe-input>
                            </template>
                            </vxe-table-column>-->
            <vxe-table-column
              field="minute"
              title="间隔分钟"
              width="120px"
              :edit-render="{
                name: '$input',
                props: {
                  type: 'integer',
                  clearable: true,
                  disabled: minuteDisabled,
                },
              }"
            />
            <vxe-table-column
              field="dataNumber"
              title="预约数"
              width="120px"
              :edit-render="{
                name: '$input',
                props: {
                  type: 'integer',
                  clearable: true,
                  disabled: dataNumberDisabled,
                },
              }"
            />
            <vxe-table-column
              field="endTime"
              title="预约结束时间"
              :edit-render="{
                name: '$input',
                props: { type: 'datetime', clearable: true, disabled: true },
              }"
            />
            <vxe-table-column title="操作" width="120px">
              <template #default="{ row }">
                <template>
                  <vxe-button
                    v-if="visitLimitFormTitle === '修改可预约数'"
                    :disabled="row.status == 2 || row.status == 1"
                    @click="removeRowEvent(row)"
                  >
                    {{ getDelete(row.status) }}
                  </vxe-button>
                  <vxe-button
                    v-if="visitLimitFormTitle === '暂停预约'"
                    :disabled="row.status == 3 || row.status == 1"
                    @click="openHandleUpdate(row.id)"
                  >
                    {{ getText(row.status) }}
                  </vxe-button>
                </template>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          v-if="this.visitLimitFormTitle === '暂停预约'"
          @click="atClose()"
        >
          关 闭
        </el-button>
        <el-button
          v-if="this.visitLimitFormTitle === '修改可预约数'"
          @click="atClose()"
        >
          取 消
        </el-button>
        <el-button
          v-if="this.visitLimitFormTitle === '修改可预约数'"
          type="primary"
          @click="visitLimitFormSubmit"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-form inline size="small">
      <el-form-item label="开始时间">
        <el-date-picker
          v-model="OutputFrom.startDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          v-model="OutputFrom.endDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-download" @click="handleUpload">
          导出
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="primary" @click="addData()">
          批量新增预约
        </el-button>
      </el-form-item>
    </el-form>
    <el-calendar>
      <template slot="dateCell" slot-scope="{ date, data }">
        <div style="height: 57px;width: 167px" @click="getNumber(data.day)">
          <p :class="data.isSelected ? 'is-selected' : ''">
            {{
              data.day
                .split("-")
                .slice(1)
                .join("-")
            }}
            <span v-if="getDate(data.day)">✔️</span>
            <span
              v-if="data.isSelected"
              style="float: right"
              class="is-selected"
            >
              可约{{ totalCan }}/{{ totalCount }}
            </span>
          </p>
          <p v-if="data.isSelected" class="is-selected">
            <el-button
              type="text"
              size="small"
              @click.stop="handleUpdate(data.day)"
            >
              编 辑
            </el-button>
            <el-button
              type="text"
              size="small"
              @click.stop="handleSelectInfo(data.day)"
            >
              详 情
            </el-button>
            <el-button
              type="text"
              size="small"
              @click.stop="openHandleUpdStatus(data.day)"
            >
              暂 停
            </el-button>
          </p>
          <span v-if="data.isSelected" class="stop"
            >时间段已暂停+{{ oneStatus }}</span
          >
        </div>
      </template>
    </el-calendar>
  </div>
</template>

<script>
import {
  addVisitLimit,
  updateVisitLimit,
  selectByUserId,
  updateStatusNoStop,
  selectOneStatus,
  existStartTime,
  canInsert,
  selectInDate,
  exists,
  updateStatusForOne,
} from "@/api/medicine/visitLimit";
import {
  selectWebCountRegister,
  updateStatus,
  deleteByLimitId,
  updateByLimitStatus,
  addVisitTime,
  batchAddVisitTime,
  selectByLimitId,
  deleteByLimitIds,
  visitRegistrationOutput,
} from "@/api/medicine/register";
import moment from "moment";

export default {
  data() {
    const timeNumberValids = ({ cellValue }) => {
      this.canInsertForm.startTime = cellValue;
      canInsert(this.canInsertForm).then((res) => {
        if (res > 0) {
          this.canInsertCount = res;
        } else {
          this.canInsertCount = res;
        }
      });
      if (cellValue == null) {
        return new Error("预约时间不能为空");
      } else if (this.canInsertCount > 0 && this.startTimeDisabled == true) {
        return "";
      } else if (this.canInsertCount > 0) {
        return new Error("时间段重叠");
      }
    };
    const dataNumberValid = ({ cellValue }) => {
      if (cellValue == null) {
        return new Error("预约数量不能为空");
      } else if (cellValue <= 0) {
        return new Error("预约数量不能小于等于0");
      }
    };
    const minuteValid = ({ cellValue }) => {
      if (cellValue == null) {
        return new Error("时间间隔不能为空");
      } else if (cellValue <= 0) {
        return new Error("时间间隔不能小于等于0");
      }
    };
    return {
      OutputFrom: {
        startDate: "",
        endDate: "",
      },
      batchDialogVisible: false,
      batchFormTitle: "",

      visitLimitDialogVisible: false,
      showDialogVisible: false,
      visitLimitFormTitle: "",
      startTimeDisabled: false,
      minuteDisabled: false,
      dataNumberDisabled: false,
      contentRule: {
        content: [
          {
            required: true,
            message: "暂停原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      statusText: "",
      totalCan: 0,
      totalCount: 0,
      oneStatus: 0,
      registerForm: {
        id: "",
        corporateName: "",
        name: "",
        idCard: "",
        model: "",
        entourage: "",
        appointment: "",
        visit: "",
        reasonRemarks: "",
      },
      visitLimitForm: {
        id: "",
        sysUserId: "",
        content: "",
        startTime: "",
        endTime: "",
        minute: "",
        dataNumber: "",
        appointment: "",
        visitLimitJson: "",
      },
      timeForm: {
        startTime: "",
        endTime: "",
        appointment: "",
      },
      visitLimitList: [],
      batchList: [],
      validRules: {
        //验证规则
        startTime: [{ validator: timeNumberValids }],
        dataNumber: [{ validator: dataNumberValid }],
        minute: [{ validator: minuteValid }],
      },
      validRulesS: {
        //验证规则
        startTime: [
          {
            required: true,
            message: "预约时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        dataNumber: [{ validator: dataNumberValid }],
        minute: [{ validator: minuteValid }],
      },
      nextWeeks: {
        startTime: "",
        endTime: "",
      },
      time: "",
      dayForm: {
        timeList: [],
        startTime: "",
      },
      nextMondayCount: 0,
      nextFridayCount: 0,
      currentDate: new Date(),
      formatDates: [],
      canDate: [],
      canInsertForm: {
        startTime: "",
      },
      inDateForm: {
        startTime: "",
      },
      canInsertCount: 0,
    };
  },
  mounted() {
    this.getDaysOfYear();
  },
  created() {
    this.makeUpdate();
    this.getNextWeekList();
  },
  methods: {
    async handleUpload() {
      const res = await visitRegistrationOutput(this.OutputFrom);
      const url = URL.createObjectURL(res);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${this.OutputFrom.startDate}至${this.OutputFrom.endDate}来访登记.xlsx`;
      link.click();
      URL.revokeObjectURL(res);
    },
    getNextWeekList() {
      const nextWeeks = moment().add(1, "week");
      const dateList = [];
      for (let i = 1; i <= 5; i++) {
        const date = nextWeeks.clone().isoWeekday(i);
        const dateString = date.format("YYYY-MM-DD");
        dateList.push(dateString);
      }
      const weekdayList = dateList.map((dateString) => `"${dateString}"`);
      this.inDateForm.startTime = weekdayList.join(",");
    },
    getDate(date) {
      for (let i = 0; i < this.canDate.length; i++) {
        if (date == this.canDate[i]) {
          return true;
        }
      }
    },
    getDaysOfYear() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate(); //年月日

      for (let day = 1; day <= daysInMonth; day++) {
        const formatDate = `${year}-${(month + 1)
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
        this.formatDates.push(formatDate); //将日期保存到数组中
      }
      this.dayForm.startTime = this.formatDates.join(",");
      existStartTime(this.dayForm).then((res) => {
        this.canDate = res;
      });
      //查询当前月份的日期并以yyyy-MM-dd显示
    },
    addData() {
      this.batchFormTitle = "批量新增预约";
      this.batchDialogVisible = true;
      let that = this;
      //let dateTime = moment().startOf('week').add(1,'week').add(1,'days').format("YYYY-MM-DD HH:mm:ss")
      //moment({hour: 10}).day(8).format("YYYY-MM-DD HH:mm:ss"); //获取下一周 周一至周五 日期 day(1)=星期一
      this.nextWeeks.startTime = moment({ hour: 10 })
        .day(8)
        .format("YYYY-MM-DD HH:mm:ss");
      this.nextWeeks.endTime = moment({ hour: 11, minute: 40 })
        .day(12)
        .format("YYYY-MM-DD HH:mm:ss");
      selectInDate(this.inDateForm).then((res) => {
        if (res > 0) {
          this.$message({
            message: "下周已(有或批量)新增！",
            customClass: "message",
          });
          let finalDay = moment({ hour: 14 })
            .day(7)
            .format("YYYY-MM-DD HH:mm:ss"); //获取下一周 周一至周五 日期
          for (var i = 1; i <= 5; i++) {
            finalDay = moment(finalDay)
              .add(1, "days")
              .format("YYYY-MM-DD HH:mm:ss");
            that.batchList.push({
              startTime: finalDay,
              minute: 5,
              dataNumber: 20,
            });
          }
        } else {
          let finalDay = moment({ hour: 10 })
            .day(7)
            .format("YYYY-MM-DD HH:mm:ss"); //获取下一周 周一至周五 日期
          for (var i = 1; i <= 5; i++) {
            finalDay = moment(finalDay)
              .add(1, "days")
              .format("YYYY-MM-DD HH:mm:ss");
            that.batchList.push({
              startTime: finalDay,
              minute: 5,
              dataNumber: 20,
            });
          }
        }
      });
    },
    async batchFormSubmit() {
      const errMap = await this.$refs.xTables
        .validate()
        .catch((errMap) => errMap);
      if (!errMap) {
        this.visitLimitForm.visitLimitJson = JSON.stringify(
          this.$refs.xTables.getTableData().tableData
        );
        exists(this.visitLimitForm).then((res) => {
          const dates = res.startTimes;
          if (dates != null || dates != "") {
            this.$refs.xTables.getTableData().tableData.forEach((item) => {
              if (dates.includes(item.startTime)) {
                // const row = this.$refs.xTables.getRow(item);
                // this.$refs.xTables.setRowClassName(row,'duplicate-row');
                //
                // const tooltipContent = `日期${item.startTime}重复了`;
                // this.$refs.xTables.setTooltipContent(row,'startTime',tooltipContent);
                this.$message.error(`日期：${item.startTime}  时段重复！`);
              }
            });
          }
          if (res.count > 0) {
            //this.$message({ message: "当前新增有时间段重复！", customClass: "message" })
          } else {
            this.$refs.batchFormRef.validate(async (valid) => {
              if (valid) {
                if (this.batchFormTitle === "批量新增预约") {
                  for (
                    let i = 0;
                    i < this.$refs.xTables.getTableData().tableData.length;
                    i++
                  ) {
                    this.$refs.xTables.getTableData().tableData[i].status = 2;
                  }
                  this.visitLimitForm.visitLimitJson = JSON.stringify(
                    this.$refs.xTables.getTableData().tableData
                  );
                  await addVisitLimit(this.visitLimitForm);
                  batchAddVisitTime();
                }
                selectWebCountRegister(this.timeForm).then((res) => {
                  this.totalCan = res.canRegister;
                  this.totalCount = res.totalRegister;
                });
                selectOneStatus(this.timeForm).then((res) => {
                  this.oneStatus = res;
                });
                this.batchDialogVisible = false;
              }
            });
          }
        });
      }
    },
    makeUpdate() {
      this.timeForm.startTime = moment().format("YYYY-MM-DD") + " 00:00:00";
      this.timeForm.endTime = moment().format("YYYY-MM-DD") + " 23:59:59";
      updateStatusNoStop(this.timeForm);
    },
    atClose() {
      this.visitLimitFormTitle = "";
      this.visitLimitDialogVisible = false;
    },
    getText(status) {
      console.log("修改可预约数");
      if (status === 1) {
        return "已暂停";
      } else if (status === 3) {
        return "已完成";
      } else {
        return "暂停";
      }
    },
    getDelete(status) {
      console.log("暂停预约");
      if (status === 2) {
        return "进行中";
      } else {
        return "删除";
      }
    },
    getNumber(date) {
      this.time = date + " 00:00:00";
      this.timeForm.startTime = date + " 00:00:00";
      this.timeForm.endTime = date + " 23:59:59";
      this.timeForm.appointment = date;
      this.getCount();
      selectOneStatus(this.timeForm).then((res) => {
        this.oneStatus = res;
      });
    },
    getCount() {
      selectWebCountRegister(this.timeForm).then((res) => {
        this.totalCan = res.canRegister;
        this.totalCount = res.totalRegister;
      });
    },
    getListByUserId() {
      selectByUserId(this.timeForm).then((res) => {
        this.visitLimitList = res;
      });
    },
    handleUpdate(date) {
      this.visitLimitForm.startTime = date + " 00:00:00";
      this.visitLimitForm.endTime = date + " 23:59:59";
      this.timeForm.startTime = date + " 00:00:00";
      this.timeForm.endTime = date + " 23:59:59";
      this.timeForm.appointment = date;
      this.visitLimitFormTitle = "修改可预约数";
      this.getListByUserId();
      this.visitLimitDialogVisible = true;
    },
    async visitLimitFormSubmit() {
      const errMap = await this.$refs.xTable
        .validate()
        .catch((errMap) => errMap);
      if (!errMap) {
        /*this.visitLimitForm.visitLimitJson = JSON.stringify(this.$refs.xTable.getTableData().tableData)
          exists(this.visitLimitForm).then(res=> {
            if (res > 0) {
              this.$message({message: "当前新增有时间段重复！", customClass: "message"})
            } else {
              */ this.$refs.visitLimitFormRef.validate(
          async (valid) => {
            if (valid) {
              if (this.visitLimitFormTitle === "修改可预约数") {
                for (
                  let i = 0;
                  i < this.$refs.xTable.getTableData().tableData.length;
                  i++
                ) {
                  if (
                    this.$refs.xTable.getTableData().tableData[i].status === 1
                  ) {
                    this.$refs.xTable.getTableData().tableData[i].status = 1;
                  } else if (
                    this.$refs.xTable.getTableData().tableData[i].status === 3
                  ) {
                    this.$refs.xTable.getTableData().tableData[i].status = 3;
                  } else {
                    this.$refs.xTable.getTableData().tableData[i].status = 2;
                  }
                }
                this.visitLimitForm.visitLimitJson = JSON.stringify(
                  this.$refs.xTable.getTableData().tableData
                );
                await updateVisitLimit(
                  this.visitLimitForm,
                  this.visitLimitForm.startTime,
                  this.visitLimitForm.endTime
                );
                addVisitTime(this.timeForm);
                updateStatusNoStop(this.timeForm);
                updateByLimitStatus();
              }
              selectWebCountRegister(this.timeForm).then((res) => {
                this.totalCan = res.canRegister;
                this.totalCount = res.totalRegister;
              });
              selectOneStatus(this.timeForm).then((res) => {
                this.oneStatus = res;
              });
              this.visitLimitFormTitle = "";
              this.visitLimitDialogVisible = false;
            }
          }
        );
      }
    },
    handleSelectInfo(date) {
      this.$router.push("/register/" + date);
    },
    openHandleUpdStatus(thisDate) {
      this.visitLimitFormTitle = "暂停预约";
      this.visitLimitForm.appointment = thisDate;
      this.timeForm.startTime = thisDate + " 00:00:00";
      this.timeForm.endTime = thisDate + " 23:59:59";
      this.timeForm.appointment = thisDate;
      this.getListByUserId();
      this.visitLimitDialogVisible = true;
    },
    openHandleUpdate(id) {
      console.log("222222222222");
      this.visitLimitForm.id = id;
      selectByLimitId(id).then((res) => {
        if (res > 0) {
          this.showDialogVisible = true;
        } else {
          updateStatusForOne(id);
          this.$confirm("确认暂停吗?", "提示", {
            type: "warning",
          }).then(async () => {
            this.getListByUserId();
            selectWebCountRegister(this.timeForm).then((res) => {
              this.totalCan = res.canRegister;
              this.totalCount = res.totalRegister;
            });
            selectOneStatus(this.timeForm).then((res) => {
              this.oneStatus = res;
            });
            this.showDialogVisible = false;
          });
        }
      });
    },
    handleUpdateStatus() {
      this.$refs.contentFormRef.validate(async (valid) => {
        if (valid) {
          this.$confirm("确认暂停?", "提示", {
            type: "warning",
          }).then(async () => {
            await updateStatus(this.visitLimitForm);
            this.getListByUserId();
            selectWebCountRegister(this.timeForm).then((res) => {
              this.totalCan = res.canRegister;
              this.totalCount = res.totalRegister;
            });
            selectOneStatus(this.timeForm).then((res) => {
              this.oneStatus = res;
            });
            this.showDialogVisible = false;
          });
        }
      });
    },
    visitLimitDialogClose() {
      this.$refs.visitLimitFormRef.resetFields(); //重置表单到初始值
      this.visitLimitList = [];
    },
    batchDialogClose() {
      this.$refs.batchFormRef.resetFields(); //重置表单到初始值
      this.batchList = [];
    },
    async insertRowEvent(row) {
      let { row: newRow } = await this.$refs.xTable.insertAt(
        { startTime: this.time },
        -1
      );
      await this.$refs.xTable.setActiveRow(newRow);
    },
    removeRowEvent(row) {
      console.log("1111111111111");
      this.$confirm("确认要删除该条数据吗?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$refs.xTable.remove(row);
        if (row.id != null) {
          deleteByLimitId(row.id);
          deleteByLimitIds(row.id);
        }
      });
    },
    removeRowEvents(row) {
      this.$confirm("确认要删除该条数据吗?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$refs.xTables.remove(row);
      });
    },
    // deleteSelected(){
    //   this.$confirm('确认要删除所选数据吗?', '提示', {
    //     type: 'warning'
    //   }).then(async () => {
    //     this.$refs.xTable.removeCheckboxRow();
    //   });
    // } ,
    editActivedEvent({ row, rowIndex }) {
      this.startTimeDisabled =
        row.status == 2 || row.status == 1 || row.status == 3;
      this.minuteDisabled =
        row.status == 2 || row.status == 1 || row.status == 3;
      this.dataNumberDisabled =
        row.status == 2 || row.status == 1 || row.status == 3;
    },
  },
};
</script>

<style>
.is-selected {
  color: #1989fa;
}
#dateInfo {
  overflow: hidden;
}
#dateInfo .stop {
  color: red;
  position: relative;
  top: -112px;
  left: 92px;
}
#dateInfo .batch {
  position: relative;
  height: 38px;
  width: 125px;
  top: 41px;
  left: 138px;
  text-align: center;
}
#dateInfo .message {
  z-index: 3300 !important;
}
</style>
